import { Box, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExtensionIcon from '@material-ui/icons/Extension';
import LinkIcon from '@material-ui/icons/Link';
import StarIcon from '@material-ui/icons/Star';
import { Link as RouterLink } from 'react-router-dom';
import { HomeEmptyState } from '../atoms/HomeEmptyState';
import { HomeFavoriteIcon } from '../atoms/HomeFavoriteIcon';
import { HomeLinkCard } from '../molecules/HomeLinkCard';
import {
  HomeSectionHeader,
  useHomeLinkStyles,
} from '../molecules/HomeSectionHeader';
import { useHomeFavoriteLinks } from '../../hooks/useHomeFavoriteLinks';
import { useHomeStarredServices } from '../../hooks/useHomeStarredServices';

export const HomeFavorites = () => {
  const classes = useStyles();
  const linkClasses = useHomeLinkStyles();
  const { links, hasMore } = useHomeFavoriteLinks();
  const services = useHomeStarredServices();

  return (
    <>
      <Box className={classes.section}>
        <HomeSectionHeader
          title="Enlaces Favoritos"
          icon={<LinkIcon />}
          count={`${links.length}${hasMore ? '+' : ''}`}
          href={hasMore ? '/shortcuts' : undefined}
        />
        {links.length === 0 ? (
          <HomeEmptyState
            favorites
            title="Aún no hay enlaces favoritos."
            action={
              <Link
                component={RouterLink}
                to="/shortcuts"
                className={linkClasses.link}
              >
                Ir a Shortcuts →
              </Link>
            }
          >
            Guarda accesos directos para mantener tus herramientas más
            utilizadas disponibles aquí.
          </HomeEmptyState>
        ) : (
          <Box className={classes.grid}>
            {links.map(link => (
              <HomeLinkCard
                key={link.id}
                title={link.title}
                href={link.url}
                icon={<HomeFavoriteIcon icon={link.icon} />}
                external
              />
            ))}
          </Box>
        )}
      </Box>
      {services.length > 0 && (
        <Box className={classes.section}>
          <HomeSectionHeader
            title="Servicios Favoritos"
            icon={<StarIcon />}
            href="/catalog"
            linkLabel="Ver catálogo →"
          />
          <Box className={classes.grid}>
            {services.map(service => (
              <HomeLinkCard
                key={`${service.kind}:${
                  service.metadata.namespace ?? 'default'
                }/${service.metadata.name}`}
                title={service.metadata.title || service.metadata.name}
                href={`/catalog/${
                  service.metadata.namespace ?? 'default'
                }/${service.kind.toLowerCase()}/${service.metadata.name}`}
                icon={
                  service.kind === 'API' ? (
                    <ExtensionIcon />
                  ) : service.kind === 'System' ? (
                    <DashboardIcon />
                  ) : (
                    <CodeIcon />
                  )
                }
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  section: { marginBottom: theme.spacing(3) },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 220px), 1fr))',
    gap: theme.spacing(1.5),
  },
}));
